import { render, staticRenderFns } from "./CommunitySearch.vue?vue&type=template&id=23dcd73c"
import script from "./CommunitySearch.vue?vue&type=script&lang=js"
export * from "./CommunitySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports